import axios from 'axios'

// Set CSRF token for all axios requests
axios.defaults.headers.common['X-CSRF-Token'] =
  document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ||
  ''

axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.withCredentials = true
